import Dropdown from './dropdown';
import DropdownButton from './dropdown-button';
Dropdown.Button = DropdownButton;
export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/dropdown/index.js
// module id = 185
// module chunks = 0